import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import itTranslations from './locales/it.json';

const resources = {
  en: {
    translation: enTranslations,
  },
  'en-GB': {
    translation: enTranslations,
  },
  'en-US': {
    translation: enTranslations,
  },
  it: {
    translation: itTranslations,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    load: 'languageOnly', // This will treat en-GB, en-US, etc. as just 'en'
    debug: false, // Set to true to debug translation issues
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false, // This prevents the app from suspending while loading translations
    },
    ns: ['translation'],
    defaultNS: 'translation',
  });

export default i18n;